<template>
  <div class="saleLogin">
    <div class="logo">
      <img
        src="http://ooso.oss-cn-hangzhou.aliyuncs.com/63991580-fe02-11ed-ac60-e5b2e2a506a6.png"
        alt=""
      />
    </div>
    <van-field
      class="salePhone"
      v-model="salePhone"
      center
      clearable
      label="手机号码"
      placeholder="请输入手机号码"
    >
    </van-field>
    <van-field
      class="password"
      v-model="password"
      center
      clearable
      label="密码"
      placeholder="请输入后台密码"
    >
    </van-field>

    <van-button class="saleLogin-fill" type="default" size="large" @click="login()"
      >登 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;陆</van-button
    >
  </div>
</template>

<script>
/* eslint-disable */
import { Dialog, Button, Popup as VanPopup } from 'vant';
import { Field, CellGroup } from 'vant';
import saleLogin from '../services/saleLogin';
import { Toast as VanToast } from 'vant';
export default {
  name: 'WangHaiDong',
  components: {
    [Dialog.Component.name]: Dialog.Component,
    [Field.name]: Field,
    Button,
    VanPopup,
    VanToast
  },
  data() {
    return {
      salePhone: undefined,
      password: undefined
    };
  },

  methods: {
    login() {
      const params = {
        mobile: this.salePhone,
        password: this.password
      };
      saleLogin.patientManagementLogin(params).then(res => {
        const id = res.data.data;
        if (res.data.code == 200) {
          VanToast.success('登陆成功');
          this.$router.push({
            path: `/patientManagementList/${id}`
          });
        } else if (res.data.code == 100) {
          VanToast.fail('密码错误');
        } else {
          VanToast.fail('账号错误，请联系管理');
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
body {
  width: 100%;
}
.salePhone {
  // background-color: ;
  width: 90%;
  position: fixed;
  top: 50%;
  left: 5%;
  border-radius: 6px;
}
.password {
  width: 90%;
  position: fixed;
  top: 60%;
  left: 5%;
  border-radius: 6px;
}
.saleLogin {
  width: 100vw;
  height: 100vh;
  background-image: linear-gradient(#208fe3, #ddf6ff);
}
.saleLogin-fill {
  position: fixed;
  top: 70%;
  left: 5%;
  width: 90%;
  border-radius: 6px;
  color: #208fe3;
  font-size: 18px;
}
.logo {
  width: 100px;
  margin: 0 auto;
  padding-top: 40%;
  img {
    width: 100%;
  }
}
</style>
